import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { homepageWidgetsClient } from '#pplx_generated/typespec/rest/homepage_widgets/client.js';
export const markUpsellAsInteracted = async (args) => {
    try {
        const { error } = await homepageWidgetsClient.POST('/rest/homepage-widgets/upsell/interacted', 'homepage upsell interaction tracking', {
            body: {
                upsell_name: args.upsellName,
                upsell_uuid: args.upsellUUID || null,
                upsell_instance_identifier: args.upsellInstanceIdentifier || null,
                interaction_type: args.interactionType || null,
            },
            timeoutMs: getQueryTimeoutMs(),
            numRetries: 1,
        });
        if (error) {
            logger.error('Failed to mark upsell as interacted', {
                upsellName: args.upsellName,
                upsellUUID: args.upsellUUID,
                upsellInstanceIdentifier: args.upsellInstanceIdentifier,
                interactionType: args.interactionType,
                error,
            });
        }
    }
    catch (error) {
        logger.error('Error marking upsell as interacted', {
            upsellName: args.upsellName,
            upsellUUID: args.upsellUUID,
            upsellInstanceIdentifier: args.upsellInstanceIdentifier,
            interactionType: args.interactionType,
            error,
        });
    }
};
//# sourceMappingURL=markUpsellAsInteracted.js.map